import t from "./isObject.js";
var i = t;
function a(r) {
  return r === r && !i(r);
}
var c = a;
export {
  c as default
};
//# sourceMappingURL=_isStrictComparable.js.map
